import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import { getAssetHeaders } from '@models/admin/organizationAssets'
import AcquisitionTypeDialog from './AcquisitionTypeDialog'
import styles from '@styles/indexPage'

const Index = ({ model, classes, organization, o }) => {
  const [selected, setSelected] = useState(null)

  const indexUrl = `/v4/o/${o}/admin/organizations/${organization.id}/assets`

  return (
    <Paper className={classes.page__wrapper} elevation={0}>
      <header className={classes.page__header}>
        <Typography component='h2' variant='h5'>
          {I18n.t('v4/organization_asset.title')}{organization ? ` — ${organization.name}` : ''}
        </Typography>
      </header>

      <Table
        tableKey='admin-organizations-assets-index'
        components={{
          Container: props => <div>{props.children}</div>
        }}
        columns={getAssetHeaders()}
        data={model.assets}
        actions={[
          rowData => ({
            icon: 'create',
            iconProps: { 'data-testid': `edit-equipment-${rowData.id}` },
            tooltip: I18n.t('v4/organization_asset.actions.edit_equipment'),
            onClick: (event, rowData) => {
              window.open(`/v4/o/${organization.id}/equipments/automatic/${rowData.id}/edit`, '_blank')
            }
          }),
          rowData => ({
            icon: 'swap_horiz',
            iconProps: { 'data-testid': `edit-acquisition-${rowData.id}` },
            tooltip: I18n.t('v4/organization_asset.actions.edit_acquisition'),
            onClick: (event, rowData) => setSelected(rowData)
          }),
          rowData => ({
            icon: 'history',
            iconProps: { 'data-testid': `timeline-${rowData.id}` },
            tooltip: I18n.t('v4/organization_asset.actions.timeline'),
            onClick: (event, rowData) => { window.location.href = `${indexUrl}/${rowData.id}/timeline` }
          })
        ]}
        options={{ showTitle: false }}
      />

      <Button
        variant='outlined'
        color='secondary'
        href={`/v4/o/${o}/admin/organizations`}
      >
        {I18n.t('actions.back')}
      </Button>

      {selected &&
        <AcquisitionTypeDialog
          key={selected.id}
          open={!!selected}
          asset={selected}
          updateUrl={`${indexUrl}/${selected.id}`}
          successUrl={indexUrl}
          onCancel={() => setSelected(null)}
        />
      }
    </Paper>
  )
}

Index.propTypes = {
  model: PropTypes.shape({
    assets: PropTypes.array
  }),
  organization: PropTypes.object,
  o: PropTypes.string
}

Index.defaultProps = {
  model: { assets: [] }
}

export default withStyles(styles)(Index)
